<template>
  <div class="container">
    <div class="left">
      <div class="plus">
        <div class="list">
          <div>流程插件</div>
          <i class="el-icon-plus" @click="handButton"></i>
        </div>
        <Navigationlist
          @handEdit="handEdit"
          @handList="handList"
          @handDeta="handDeta"
          :ItemData="ItemData"
          :active="active"
        >
        </Navigationlist>
        <el-dialog
          :title="title"
          :visible.sync="pupupTable"
          width="30%"
          modal
          :close-on-click-modal="false"
          :show-close="false"
          destroy-on-close
          @close="close"
          append-to-body
        >
          <el-form
            class="login-form"
            label-position="top"
            label-width="80px"
            :model="mode"
            :rules="rules"
            ref="mode"
          >
            <el-form-item prop="name" label="扩展">
              <el-input
                placeholder="请输入扩展名"
                v-model="mode.name"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="图片 (图片大小5MB以内)"
              prop="logo_url"
              :rules="{
                required: true,
                message: '请选择文件',
                trigger: 'change',
              }"
            >
              <el-upload
                class="upload-demo"
                :action="action"
                :headers="headers"
                :limit="1"
                :data="fileListData"
                :file-list="mode.logo_url"
                accept=".jpeg,.png,.jpg,.bmp,.gif"
                list-type="picture"
                :on-error="handleError"
                :before-upload="handleUpload"
                :on-success="handLesuccess"
                :on-change="handleChangeContent"
                :on-remove="handOnremoveChange"
                :on-exceed="uploadExceed"
              >
                <!-- :before-remove="beforeRemove" -->
                <el-button slot="trigger" size="small" type="primary"
                  >选取图片</el-button
                >
              </el-upload>
            </el-form-item>
            <el-form-item prop="description" label="说明">
              <el-input
                type="textarea"
                :rows="5"
                placeholder="说明"
                v-model="mode.description"
              ></el-input>
            </el-form-item>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button @click="handClickCancel">取 消</el-button>
            <el-button v-if="flag" type="primary" @click="handButtonConfirm"
              >确 定</el-button
            >
            <el-button v-if="show" type="primary" @click="handEaditConfirm"
              >确 定</el-button
            >
          </span>
        </el-dialog>
      </div>

      <div class="br"></div>
    </div>

    <div class="right">
      <div class="flex-list">
        <el-button
          size="small"
          type="primary"
          icon="el-icon-plus"
          @click="handDetaClick()"
          >新建
        </el-button>
      </div>
      <div class="distance">
        <el-table :data="tableData" style="width: 100%">
          <el-table-column prop="name" label="版本"> </el-table-column>
          <el-table-column
            prop="description"
            label="版本说明"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column label="平台">
            <template slot-scope="scope">
             <p style="position: relative; top: -11px;">{{scope.row.platform?'linux':'windows'}}</p>
            </template>
          </el-table-column>
          <el-table-column prop="user_download_records_count" label="下载次数">
          </el-table-column>
          <el-table-column prop="created_at" label="创建时间">
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-tooltip content="编辑" placement="top">
                <el-button
                  @click="handleClick(scope.row)"
                  class="size"
                  type="text"
                  size="small"
                  icon="el-icon-edit-outline"
                ></el-button>
              </el-tooltip>
              <el-tooltip content="删除" placement="top">
                <el-button
                  type="text"
                  size="small"
                  @click="handLeButton(scope.row)"
                  class="size"
                  icon="el-icon-delete"
                  style="padding-left: 15px"
                >
                </el-button>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <pagingVue
        :Pagination="Pagination"
        :tableData="tableData"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
      ></pagingVue>

      <div>
        <el-dialog
          title="新建版本"
          :visible.sync="centerDialogVisible"
          width="30%"
          modal
          :close-on-click-modal="false"
          :show-close="false"
          destroy-on-close
          @close="close"
          append-to-body
        >
          <el-form
            class="login-form"
            label-position="top"
            label-width="80px"
            :model="useName"
            :rules="rules"
            ref="useName"
          >
            <el-form-item prop="name" label="版本">
              <el-input
                placeholder="请输入版本号"
                v-model="useName.name"
              ></el-input>
            </el-form-item>
            <el-form-item prop="download_url" label="下载路径">
              <el-input
                placeholder="请输入下载路径"
                v-model="useName.download_url"
              ></el-input>
            </el-form-item>
            <el-form-item label="扩展所属平台" prop="platform">
              <el-radio-group v-model="useName.platform">
                <el-radio label="0">windows</el-radio>
                <el-radio label="1">linux</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item prop="description" label="说明">
              <el-input
                type="textarea"
                :rows="5"
                placeholder="说明"
                v-model="useName.description"
              ></el-input>
            </el-form-item>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button @click="handCancel">取 消</el-button>
            <el-button type="primary" @click="handConfirm">确 定</el-button>
          </span>
        </el-dialog>

        <el-dialog
          title="编辑版本"
          :visible.sync="Popup"
          width="30%"
          modal
          :close-on-click-modal="false"
          :show-close="false"
          destroy-on-close
          @close="close"
          append-to-body
        >
          <el-form
            class="login-form"
            label-position="top"
            label-width="80px"
            :model="modify"
            :rules="rules"
            ref="modify"
          >
            <el-form-item prop="name" label="版本">
              <el-input
                placeholder="请输入版本号"
                v-model="modify.name"
              ></el-input>
            </el-form-item>

            <el-form-item prop="download_url" label="下载路径">
              <el-input
                placeholder="请输入下载路径"
                v-model="modify.download_url"
              ></el-input>
            </el-form-item>
            <el-form-item label="扩展所属平台" prop="platform">
              <el-radio-group v-model="modify.platform">
                <el-radio label="0">windows</el-radio>
                <el-radio label="1">linux</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item prop="description" label="说明">
              <el-input
                type="textarea"
                :rows="5"
                placeholder="说明"
                v-model="modify.description"
              ></el-input>
            </el-form-item>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button @click="handClickCancel">取 消</el-button>
            <el-button type="primary" @click="handClickConfirm"
              >确 定</el-button
            >
          </span>
        </el-dialog>
      </div>
    </div>
  </div>
</template>
<script>
import { baseURL } from "@/api/request";
import Navigationlist from "../../../components/Navigationlist/NavTable.vue";
import pagingVue from "../../../components/Paging/paging.vue";
export default {
  name: "Member_role",
  data() {
    var downloadurlvalid = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("下载路径不能为空"));
      }
      let reg_tel = /(http|https|ftp):\/\/([\w.]+\/?)\S*/;
      if (!reg_tel.test(value)) {
        return callback(new Error("请输入正确下载路径"));
      } else {
        callback();
      }
    };
    return {
      title: "",
      show: false,
      flag: false,
      pupupTable: false,
      Popupvisible: false,
      action: baseURL + "admin/upload-oss-file",
      headers: {
        Authorization: "Bearer" + sessionStorage.getItem("token"),
      },
      Workers: {
        extension_id: "", //	扩展组ID
      }, //搜索匹配worker
      active: "0",
      //擅长 编辑 id
      delete: {
        id: "",
      },
      Worker: {
        id: "",
      },
      extensionsType: {
        type: "1",
      },
      ItemData: [],
      //分页数据
      Pagination: {},
      workerid: "", //选中扩展组
      workerhoverid: "", //默认选中的扩展组
      useName: {
        name: "",
        download_url: "",
        platform:"",
        extension_id: "",
        description: "",
      },
      mode: {
        id: "",
        type: "1",
        name: "",
        filename: "",
        logo_url: [],
        description: "",
      }, //编辑和新增

      model: {
        id: "",
        type: "1",
        name: "",
        logo_url: "",
        description: "",
      },
      modelList: {
        id: "",
        type: "1",
        name: "",
        logo_url: "",
        description: "",
      },
      modify: {
        id: "",
        name: "",
        download_url: "",
        platform:"",
        extension_id: "",
        description: "",
      },
      fileListData: {
        filename: "",
      },
      tableData: [],
      centerDialogVisible: false,
      Popup: false,

      rules: {
        name: [
          { required: true, message: "请输入名称", trigger: "blur" },
          { min: 2, message: "长度至少2个字符", trigger: "blur" },
        ],
        platform: [
            { required: true, message: '请选择扩展所属平台', trigger: 'change' }
          ],
        download_url: [
          {
            required: true,
            validator: downloadurlvalid,
            trigger: "blur",
            trigger: "blur",
          },
        ],
        extension_id: [
          { required: true, message: "请选择扩展组", trigger: "blur" },
        ],
        // description: [
        //   { required: true, message: "请输入内容", trigger: "blur" },
        // ],
      },
    };
  },
  components: {
    Navigationlist,
    pagingVue,
  },
  created() {
    this.Itemlist();
  },
  // mounted() {
  //   this.devicesList();

  // },
  methods: {
    clear() {
      this.active = "";
      this.Workers = {};
      this.devicesList();
    },
    handButton() {
      this.flag = true;
      this.show = false;
      this.title = "新增扩展组";
      this.pupupTable = true;
    },

    handList(params) {
      let { id, item } = params;
      this.active = id.toString();
      this.Workers.extension_id = item.id;
      sessionStorage.setItem("extension_id", item.id);
      this.useName.extension_id = item.id;
      this.devicesList();
    },
    //查询状态

    //新增扩展
    handButtonConfirm() {
      console.log(this.mode);
      this.model.name = this.mode.name;
      this.model.type = "1";
      this.model.description = this.mode.description;
      this.$refs.mode.validate(async (valid) => {
        if (valid) {
          const res = await this.$axios.postListData(
            "admin/extensions",
            this.model
          );
          if (res.code == 200) {
            this.pupupTable = false;
           
            this.Itemlist();
            this.mode.logo_url = []
            this.mode.name = "";
            this.mode.description =''
          }
        } else {
          return false;
        }
      });
    },
    handleError(err, file, fileList) {
      this.$message.error("文件上传失败，请重新上传");
    },
    handleUpload(file) {
      const fileName = file.name
      const fileType = fileName.substring(fileName.lastIndexOf('.'))
      // jpeg,.png,.jpg,.bmp,.gif
      if (
        fileType === '.jpg' ||
        fileType === '.png' ||
        fileType === '.jpeg' ||
        fileType === '.bmp' ||
        fileType === '.gif'
      ) {
        // 不处理
      } else {
        this.$message.error(
          '不是,jpeg,.png,.jpg,.bmp,.gif文件,请上传正确的图片类型'
        )
        return false
      }

      // let fileName = file.name;
      // let pos = fileName.lastIndexOf(".");
      // let lastName = fileName.substring(pos, fileName.length);
      // if (
      //   lastName.toLowerCase() !== ".zip" &&
      //   lastName.toLowerCase() !== ".rar" &&
      //   lastName.toLowerCase() !== ".docx" &&
      //   lastName.toLowerCase() !== ".ppt" &&
      //   lastName.toLowerCase() !== ".pdf" &&
      //   lastName.toLowerCase() !== ".jpeg" &&
      //   lastName.toLowerCase() !== ".png" &&
      //   lastName.toLowerCase() !== ".gif"
      // ) {
      //   this.$message.error(
      //     "文件必须为.rar .zip .doc .docx .pdf.ppt.png.gif.jpeg 类型"
      //   );
      //   return;
      // }
      // 限制上传文件的大小
      const isLt = file.size / 1024 / 1024 / 10 <= 1;
      if (!isLt) {
        this.$message.error("上传文件大小不得大于10MB!");
      }
      return isLt;
    },
    handLesuccess(response, file, fileList) {
      if (response.code == 200) {
        this.model.logo_url = response.data.fullpath;
        this.modelList.logo_url = response.data.fullpath;
      }
    },
    handleChangeContent(file, fileList) {
      let fileName = file.name;
      let uid = file.uid;
      let pos = fileName.lastIndexOf(".");
      console.log(fileList);
      // let lastName = fileName.substring(pos, fileName.length);
      this.mode.logo_url = fileList;
      if (this.mode.logo_url) {
        this.$nextTick(() => {
          this.$refs.mode.clearValidate("logo_url");
        });
      }
      // if (
      //   lastName.toLowerCase() !== ".zip" &&
      //   lastName.toLowerCase() !== ".rar" &&
      //   lastName.toLowerCase() !== ".docx" &&
      //   lastName.toLowerCase() !== ".ppt" &&
      //   lastName.toLowerCase() !== ".pdf" &&
      //   lastName.toLowerCase() !== ".jpeg" &&
      //   lastName.toLowerCase() !== ".png" &&
      //   lastName.toLowerCase() !== ".gif"
      // ) {
      //   this.$message.error(
      //     "文件必须为.rar .zip .doc .docx .pdf.ppt.png.gif.jpeg 类型"
      //   );
      //   // this.resetCompressData()
      //   for (var i = 0; i < fileList.length; i++) {
      //     if (fileList[i].uid == uid) {
      //       fileList.splice(i, 1);
      //     }
      //   }
      //   return;
      // }
      // 限制上传文件的大小
      const isLt = file.size / 1024 / 1024 / 5 <= 1;
      if (!isLt) {
        this.$message.error("上传文件不得大于10MB!");
        for (var i = 0; i < fileList.length; i++) {
          if (fileList[i].uid == uid) {
            fileList.splice(i, 1);
          }
        }
      }
      return isLt;
    },
    handOnremoveChange(file, fileList) {
      this.mode.logo_url = fileList;
      this.$refs.mode.validateField("logo_url");
    },
    // beforeRemoveChange(file, fileList) {
    //   return this.$confirm(`确定移除 ${file.name}？`);
    // },
    uploadExceed() {
      this.$message.error(
        "您已添加了一个文件，如需替换，请先删除已添加的文件！"
      );
    },
    //扩展组列表
    async Itemlist() {
      const res = await this.$axios.getListData(
        "admin/extensions",
        this.extensionsType
      );
      if (res.code == 200) {
        console.log(res.data);
        if (res.data.length) {
          this.active = res.data[0].id.toString();
          this.Workers.extension_id = res.data[0].id.toString();
          sessionStorage.setItem("extension_id", res.data[0].id.toString());
          this.useName.extension_id = res.data[0].id.toString();
          this.devicesList();
        }
        if (Object.keys(res.data).length != 0) {
          this.ItemData = res.data;
        } else {
          this.ItemData = [];
        }
      }
    },
    //编辑扩展组
    handEdit(params) {
      let { name, description, id, logo_url } = params;
      this.$set(this.mode, "name", name);
      this.$set(this.mode, "description", description);
      this.$set(this.mode, "logo_url", [
        { name: logo_url.slice(-44), url: logo_url },
      ]);
      console.log(logo_url.split());

      this.modelList.id = id;
      this.modelList.logo_url = logo_url;
      this.modelList.name = name;
      this.modelList.description = description;

      this.show = true;
      this.flag = false;
      this.title = "编辑worker组";
      this.pupupTable = true;
    },
    //确定编辑内容
    handEaditConfirm() {
      this.modelList.name = this.mode.name;
      this.modelList.description = this.mode.description;
      if (!this.mode.description) {
        delete this.mode.description;
      }
      this.$refs.mode.validate((valid) => {
        if (valid) {
          this.$axios
            .postListData("admin/update-extension", this.modelList)
            .then((res) => {
              if (res.code == 200) {
                this.pupupTable = false;
                this.$set(this.mode, "logo_url", []);
                this.$set(this.mode, "name", "");
                this.$set(this.mode, "description", "");
                this.Itemlist();
              }
            });
        }
      });
    },
    //扩展组删除
    handDeta(id) {
      this.delete.id = id;
      this.$confirm("是否删除, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$axios
            .getListData("admin/delete-extension", this.delete)
            .then((res) => {
              if (res.code == 200) {
                this.Itemlist();
                this.devicesList();
              }
            });
        })
        .catch(() => {});
    },

    // //新建版本
    handDetaClick() {
      this.centerDialogVisible = true;
    },
    //版本列表
    devicesList() {
      this.$axios
        .getListData("admin/extension-versions", this.Workers)
        .then((res) => {
          if (res.code === 200) {
            this.Pagination = res.data.meta.pagination;
            let time = res.data.data;
            console.log(res.data.data);
            this.tableData = time.map((v) => {
              return {
                ...v,
                description: v.description ? v.description : "——",
                name: v.name ? v.name : "一",
              
                created_at: this.$inserted(v.created_at),
              };
            });
          }
        });
    },

    close() {
      this.pupupTable = false;
      this.centerDialogVisible = false;
      this.useName = {};
      this.modify = {};
      this.Popup = false;
    },
    handCancel() {
      this.centerDialogVisible = false;
      this.useName = {};
    },
    handleChange(e) {
      this.workerid = e;
      this.Workers.extension_id = e;
    },
    //新建版本
    handConfirm() {
      if (!this.useName.description) {
        delete this.useName.description;
      }
      if(!this.useName.extension_id){
         this.useName.extension_id = sessionStorage.getItem('extension_id')
       }
      this.$refs.useName.validate((valid) => {
        if (valid) {
          this.$axios
            .postListData("admin/extension-versions", this.useName)
            .then((res) => {
              if ((res.code = 200)) {
                this.centerDialogVisible = false;
                if (this.workerid) {
                  this.active = this.workerid.toString();
                }
                this.devicesList();
              }
            });
        } else {
          return false;
        }
      });
    },

    handleClick(e) {
      console.log(e);

      this.$set(
        this.modify,
        "extension_id",
        e.extension_id ? e.extension_id : ""
      );
      this.$set(this.modify, "download_url", e.download_url);
      this.$set(this.modify, "platform", e.platform+'');
      this.$set(this.modify, "name", e.name);
      this.$set(this.modify, "description", e.description);
      this.modify.id = e.id;
      this.Popup = true;
    },
    handClickCancel() {
      this.pupupTable = false;
      this.Popupvisible = false;
      this.Popup = false;
      this.mode = {};
      this.modify = {};
    },

    handleClose() {
      this.drawer = false;
    },

    //编辑版本
    handClickConfirm() {
      if (!this.modify.description) {
        delete this.modify.description;
      }
      this.$refs.modify.validate((valid) => {
        if (valid) {
          this.$axios
            .postListData("admin/update-extension-version", this.modify)
            .then((res) => {
              this.Popup = false;
              if (this.workerid) {
                this.active = this.workerid.toString();
              }
              this.devicesList();
              this.workerid = "";
            });
        }
      });
    },
    //删除版本
    handLeButton(e) {
      this.delete.id = e.id;
      this.$confirm("是否删除, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$axios
            .getListData("admin/delete-extension-version", this.delete)
            .then((res) => {
              if (res.code === 200) {
                if (this.tableData.length > 1) {
                  this.devicesList();
                } else {
                  if (this.Workers.page >= 2) {
                    this.Workers.page = this.Workers.page - 1;
                    this.devicesList();
                  } else {
                    this.devicesList();
                  }
                }
              } else {
                this.$message({
                  showClose: true,
                  message: res.message,
                  type: "success",
                });
              }
            });
        })
        .catch(() => {});
    },

    handleSizeChange(val) {
      this.Pagination.per_page = val;
    },
    //分页
    handleCurrentChange(val) {
      this.Workers.page = val;
      this.devicesList();
    },
  },
};
</script>

<style scoped lang="less" scoped>
/deep/.cell {
  max-height: 28px !important;
}
/deep/.el-table__empty-text {
  line-height: 53px;
}
/deep/.el-table__empty-block {
  min-height: 53px;
}
/deep/.el-descriptions :not(.is-bordered) .el-descriptions-item__cell {
  display: flex;
}
/deep/.el-descriptions-item__container .el-descriptions-item__content {
  width: 130px;
  display: block;
  text-align: right;
  padding-right: 10px;
}
.distance {
  margin: 10px 0;
}
/deep/.el-descriptions-item__container {
  width: 200px;
  display: flex;
  box-sizing: border-box;
  justify-content: space-between;
  align-items: center;
  height: 40px;
  color: #000;
  border-radius: 4px;
  background-color: rgba(34, 73, 192, 0.06);
}
/deep/.el-descriptions-item__label:not(.is-bordered-label) {
  padding-left: 10px;
}
/deep/.el-select {
  width: 100% !important;
}

/deep/.el-dialog__body {
  box-sizing: border-box;
  padding: 20px;
}
/deep/.el-button--text {
  font-size: 18px;
  margin-top: -8px;
}
/deep/.el-form-item {
  margin-bottom: 20px !important;
}
/deep/.el-table__body {
  width: 100% !important;
}
.dialog-footer {
  display: flex !important;
  justify-content: space-around !important;
}
.list {
  width: 92%;
  margin: 10px 0;
  box-sizing: border-box;
  padding: 0 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.container {
  width: 100%;
  box-sizing: border-box;
  padding: 22px;
  overflow: hidden;
  display: flex;
  .left {
    width: 18%;
    display: flex;
    justify-content: center;

    .my-label {
      background-color: #e1f3d8;
    }

    .my-content {
      background-color: #fde2e2;
    }
    .plus {
      padding: 10px;
      width: 100%;
    }
    .button-padding {
      width: 200px;
      color: #fff;
      height: 32px;
      background-color: #409eff;
      border-color: #409eff;
    }
    .br {
      margin: auto;
      padding-right: 25px;
      height: calc(100vh - 155px);
      border-left: 1px solid #e6e7ec;
    }
  }
  .right {
    width: 82%;
    .flex-list {
      display: flex;
      align-items: center;
      justify-content: flex-end;
    }
  }
}
</style>
